SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

SCM.Utilities.Reveal = (function ($) {
    var _targetIdAttr = 'data-reveal-id';
    var _modalClass = 'reveal-modal';
    var _closeTriggerClass = 'close-reveal-modal';
    var _modalOpenClass = 'open';
    var _bodyOpenClass = 'on-canvas';
    var $body = $(document.body);
    let _focusTrapInitialized = false;

    return {
        init: _init,
        open: _open,
        close: _close,
        toggle: _toggle
    };

    /**
     * Initialize automatic open and closing of modal tagged with appropriate classes and attributes.
     *
     * @param {Object} [options] Control how the reveal functionality behaves
     * @param {string} [options.targetIdAttr] The HTML attribute that holds the ID of the target modal
     * @param {string} [options.modalClass] The class that identifies an element as a reveal modal
     * @param {string} [options.closeTriggerClass] The class that identifies an element that will trigger closing the modal
     * @param {string} [options.modalOpenClass] The class that will be added to a modal to indicate that it is open
     * @param {string} [options.bodyOpenClass] The class that will (optionally) be added to the body element to indicate that a modal is open
     */
    function _init(options) {
        _setOptions(options);
        var revealTriggerSelector = '*[' + _targetIdAttr + ']';
        $body.on('click', revealTriggerSelector, function (event) { _handleRevealTriggerClick(event.currentTarget); });
        var closeTriggerSelector = '.' + _closeTriggerClass;
        $body.on('click', closeTriggerSelector, function (event) { _handleCloseTriggerClick(event.currentTarget); });
        _initFocusTrap();
    }

     /**
     * Open the specified modal(s)
     *
     * @param {JQuery|HTMLElement|string} $elements The modal element(s) to open.  If a string is provided, it will be
     * interpreted as a CSS selector that specifies the element(s) to open.
     * @param {boolean} [addBodyClass] Whether or not to add the "modal open" class to the body element
     */
    function _open($elements, addBodyClass) {
        if (typeof $elements === 'string' || $elements instanceof Element) {
            $elements = $($elements);
        }

        $elements.addClass(_modalOpenClass);
        if (addBodyClass && _bodyOpenClass) {
            $body.addClass(_bodyOpenClass);
        }
    }

    /**
     * Close the specified modal(s)
     *
     * @param {JQuery|HTMLElement|string} $elements The modal element(s) to close.  If a string is provided, it will be
     * interpreted as a CSS selector that specifies the element(s) to close.
     */
    function _close($elements) {
        if (typeof $elements === 'string' || $elements instanceof Element) {
            $elements = $($elements);
        }

        $elements.removeClass(_modalOpenClass);
        if (_bodyOpenClass) {
            $body.removeClass(_bodyOpenClass);
        }
    }

    function _handleRevealTriggerClick(clickTarget) {
        var targetId = $(clickTarget).attr(_targetIdAttr);
        var $target = $('#' + targetId);
        if ($target.length) {
            _open($target);
        }
    }

    function _handleCloseTriggerClick(clickTarget) {
        var $boundingModal = $(clickTarget).closest('.' + _modalClass);
        if ($boundingModal.length) {
            _close($boundingModal);
        }
    }

    /**
     * Toggle the specified modal(s)
     *
     * @param {JQuery|HTMLElement|string} $elements The modal element(s) to toggle.  If a string is provided, it will be
     * interpreted as a CSS selector that specifies the element(s) to toggle.
     */
    function _toggle($elements) {
        if (typeof $elements === 'string' || $elements instanceof Element) {
            $elements = $($elements);
        }

        $elements.each(function(i, elem) {
            var $elem = $(elem);
            if ($elem.hasClass(_modalOpenClass)) {
                _close($elem);
            } else {
                _open($elem);
            }
        });
    }

    function _initFocusTrap() {
        if (_focusTrapInitialized) {
            return;
        }
        _focusTrapInitialized = true;

        const openModalSelector = '.' + _modalClass + '.' + _modalOpenClass;

        $body.on('keydown.SCM.Reveal', openModalSelector, function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                _close($(this));
            }
        });

        $('.mobile-mask').on('click.SCM.Reveal', function () {
            const $openModal = $(openModalSelector).last();
            if ($openModal.length) {
                _close($openModal);
            }
        });

        _observeModalOpenChanges();
    }

    function _observeModalOpenChanges() {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(_handleModalClassChange);
        });
        observer.observe($body[0], {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
        });
    }

    function _handleModalClassChange(mutation) {
        const $modal = $(mutation.target);
        if (!$modal.hasClass(_modalClass)) {
            return;
        }
        const isOpen = $modal.hasClass(_modalOpenClass);
        if (isOpen && !$modal.data('focusTrapped')) {
            $modal.data('focusTrapped', true);
            SCM.Focus.trap($modal);
        } else if (!isOpen && $modal.data('focusTrapped')) {
            $modal.data('focusTrapped', false);
            SCM.Focus.release($modal);
        }
    }

    function _setOptions(options) {
        if (!options || typeof options !== 'object') {
            return;
        }
        options.targetIdAttr && (_targetIdAttr = options.targetIdAttr);
        options.modalClass && (_modalClass = options.modalClass);
        options.closeTriggerClass && (_closeTriggerClass = options.closeTriggerClass);
        options.modalOpenClass && (_modalOpenClass = options.modalOpenClass);
        options.bodyOpenClass && (_bodyOpenClass = options.bodyOpenClass);

    }

})(jQuery);
